<script setup>
import { defineProps,defineEmits} from "vue";
// import NotaFiscalService from "@/api/v2/services/NotaFiscalService.js";
import UtilMoney from "@/utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "controlesDesativados",
    "dado",
    "contaAPagar",
    "pagamento",
]);

const emits = defineEmits([
    "update:alteraPagamento",
]);

//==================================================================//
//====================== Altera Pagamento ==========================//
//==================================================================//

const alteraPagamento = (update)=>{

    update.id = props?.pagamento?.id;
    emits('update:alteraPagamento',update);

};

// //==================================================================//
// //==================== get Nota Fiscal Recebida ====================//
// //==================================================================//

// const getNotaFiscalRecebida = async ()=>{

//     let notaFiscalValores = {
//         nomeArquivo: props?.pagamento.notaFiscalRecebidaChaveAcesso,
//         plugNotasId: props?.pagamento.notaFiscalRecebidaPlugNotasID,
//     }

//     let notaFiscalResponse = await NotaFiscalService.getNotaFiscalByPlugNotasId(notaFiscalValores);
//     if(notaFiscalResponse.status != "200"){
//         throw new Error(`${notaFiscalResponse.message}`)
//     }

// };

//==================================================================//
//================== Ao Selecionar Pagamento =======================//
//==================================================================//

const aoSelecionarPagamento = ()=>{

    alteraPagamento({
        selecionado: !props?.pagamento?.selecionado,
    })

};

</script>

<template>

    <div
        class="c-table__row"
    >

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-checkbox
                    class="c-checkbox"
                    :value="props?.pagamento?.selecionado"
                    :disabled="props?.controlesDesativados"
                    @change="aoSelecionarPagamento"
                ></v-checkbox>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-cash-multiple
                    </v-icon>

                    <span
                        class="c-table__cell-content-text"
                    >
                        {{props?.pagamento?.sequencia}}
                    </span>
                    

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.pagamento?.tipo}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.pagamento?.status}}

            </div>

        </div>

        <!-- <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn
                            v-show="props?.pagamento?.notaFiscalRecebidaID"
                            class="mx-2"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="getNotaFiscalRecebida"
                        >

                            <v-icon dark>
                                mdi-eye
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Visualizar Nota Fiscal Recebida</span>

                </v-tooltip>

                {{props?.pagamento?.notaFiscalRecebidaNumero}}

            </div>

        </div> -->

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.pagamento?.dataCriacao}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{props?.pagamento?.dataVencimento}}

            </div>

        </div>

         <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorDesconto)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorPagamento)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorReservado)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorParaPagar)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorPago)}}

            </div>

        </div>

        <!-- <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorParaVincular)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.pagamento?.valorVinculado)}}

            </div>

        </div> -->

        <div class="c-table__cell">

            <div class="c-table__cell-content"></div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: contents;
}

.c-table__row:hover > .c-table__cell{
    background-color: #f0f0f0;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
    font-size: 0.875rem;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

.c-checkbox >>> .v-icon{
    font-size: 26px;
}

.c-checkbox >>> .v-input--selection-controls__input{
    margin: 0px;
}

.c-checkbox.v-input--is-label-active >>> .v-input--selection-controls__ripple{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.c-checkbox.v-input--is-label-active >>> .v-icon{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-nota-fiscal-recebida{
    background: #3F51B5 !important;
    border-color: #3F51B5 !important;
}

</style>
